import API_URLS from '../../constants/api-urls';

const URLS_TO_IGNORE: string[] = [API_URLS.CHANGE_EMAIL_CONFIRM];

const should401BeIgnored = (url = ''): boolean => {
    return URLS_TO_IGNORE.some((str) => `${url}`.includes(str));
};

export default should401BeIgnored;
